import { Component, computed, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsContent } from '@fcom/core-api/interfaces/cms-interface';

@Component({
  selector: 'cms-important-links',
  styleUrls: ['./cms-important-links.component.scss'],
  templateUrl: './cms-important-links.component.html',
  standalone: false,
})
export class CmsImportantLinksComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input.required<CmsCollection>();

  items = computed((): CmsContent[] => {
    return this.content()?.items ?? [];
  });
}
